import { render } from "./ConfirmPreviousReportedDamage.vue?vue&type=template&id=21919314&ts=true"
import script from "./ConfirmPreviousReportedDamage.vue?vue&type=script&lang=ts"
export * from "./ConfirmPreviousReportedDamage.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__